import {
	baseCol,
	fileCol,
	htmlCol,
	idCol,
	idNumberCol,
	linkCol,
	multiFilterCol,
	numberCol,
	setCol,
	textCol
} from "./columnTypes/baseTypes";
import {iconCol} from "./columnTypes/iconCol";
import {serverSideSetCol} from "./columnTypes/serverSideSetCol";
import {boolCol} from "./columnTypes/boolCol";
import {nullableBoolCol} from "./columnTypes/nullableBoolCol";
import {dateCol} from "./columnTypes/dateCol";
import {deleteCol} from "./columnTypes/deleteCol";
import {idK1UserCol} from "./columnTypes/idK1UserCol";

export let gridColumnTypes = {
	"baseCol": baseCol,
	"textCol": textCol,
	"htmlCol": htmlCol,
	"fileCol": fileCol,
	"linkCol": linkCol,
	"iconCol": iconCol,
	"setCol": setCol,
	"setColServerSide": serverSideSetCol,
	"boolCol": boolCol,
	"nullableBoolCol": nullableBoolCol,
	"numberCol": numberCol,
	"idCol": idCol,
	"idColNumber": idNumberCol,
	"dateCol": dateCol,
	"idK1UserCol": idK1UserCol,
	"deleteCol": deleteCol,
	"multiFilterCol": multiFilterCol
};

window.gridColumnTypes = gridColumnTypes
